import { Grid } from '@mui/material';
import { ODSAccordion } from '@telekom-ods/react-ui-kit';
import type { CSSProperties, ReactNode } from 'react';
import React from 'react';

interface AccordionProps {
  title: string | ReactNode;
  details?: ReactNode;
  children?: ReactNode;
  size?: 'small' | 'large';
  expanded: boolean;
  className?: string;
  style?: CSSProperties;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  details,
  children,
  size = 'large',
  expanded,
  className,
  style,
}): React.ReactElement => {
  const content: React.ReactElement = (
    <Grid
      container
      direction='column'
      margin={2}
    >
      {details}
      {children}
    </Grid>
  );

  return (
    <ODSAccordion
      className={className}
      style={style}
      headerText={title}
      contentSlot={content}
      size={size}
      expanded={expanded}
    />
  );
};

export default Accordion;
